/**
 * Hook to sync language preference with backend
 * Updates user language preference in database when changed
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import axiosInstance from '../api/axios';

export const useLanguageSync = () => {
  const { i18n } = useTranslation();
  const token = useSelector((state: RootState) => state.auth.token);
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  useEffect(() => {
    const syncLanguage = async (language: string) => {
      // Only sync if user is authenticated
      if (!isAuthenticated || !token) {
        return;
      }

      try {
        // Update language preference in backend
        await axiosInstance.put('/auth/language', { language });
      } catch (error) {
        console.error('Failed to sync language preference:', error);
        // Don't throw error, just log it
      }
    };

    // Listen for language changes
    const handleLanguageChange = (lng: string) => {
      syncLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, isAuthenticated, token]);
};
